import React from "react";
import { ALL_GAMES } from "../types.ts";

const GAME_META: Record<string, { color: string; emoji: string }> = {
  foldaway: { color: "#A78BFA", emoji: "\uD83D\uDCD0" },
  spillover: { color: "#4ECAFF", emoji: "\uD83D\uDCA7" },
  lockstep: { color: "#FFD166", emoji: "\u2699\uFE0F" },
  burnout: { color: "#FF6B6B", emoji: "\uD83D\uDD25" },
  echo: { color: "#00F0A0", emoji: "\uD83D\uDCE1" },
};

export function DailyFiveProgress({ completedGames }: { completedGames: Set<string> }) {
  const done = ALL_GAMES.filter(g => completedGames.has(g)).length;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 px-4 py-2 rounded-full border border-dark-gray"
      style={{ background: "rgba(20,23,41,0.92)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)" }}
    >
      <span className="font-mono text-[10px] tracking-[1px] text-warm-gray mr-1">{done}/5</span>
      {ALL_GAMES.map(g => {
        const meta = GAME_META[g];
        const isDone = completedGames.has(g);
        return (
          <div
            key={g}
            className="w-2.5 h-2.5 rounded-full transition-all duration-300"
            style={{
              background: isDone ? meta.color : "rgba(255,255,255,0.08)",
              boxShadow: isDone ? `0 0 6px ${meta.color}40` : "none",
            }}
            title={g}
          />
        );
      })}
    </div>
  );
}
